import styled from 'styled-components';
import { Popper } from '@mui/material';

import colors from '../../styles/colors';

const Wrapper = styled.div`
  /*
   * Transparent wrapper — purely a DOM anchor to scope text-selection
   * detection to its children without generating a box of its own.
   * Using \`display: contents\` keeps the surrounding layout (e.g. chat
   * bubbles, accordion rows) untouched.
   */
  display: contents;
`;

const StyledPopper = styled(Popper)`
  /*
   * Keep the floating menu above MUI dialogs/tooltips but below
   * modals that take over the full screen.
   */
  z-index: 1300;
`;

const MenuList = styled.div`
  display: inline-flex;
  flex-direction: column;
  gap: 4px;
  background: ${colors.base.alpha};
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  padding: 4px;
`;

const MenuButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: ${colors.base.secondary2};
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  text-align: left;
  white-space: nowrap;

  &:hover {
    background: ${colors.base.primary};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export {
  Wrapper,
  StyledPopper,
  MenuList,
  MenuButton,
};
